import {Pipe, PipeTransform} from "@angular/core";
import {TranslateService} from "@ngx-translate/core";
import {NoticeEntry} from "../../pages/client/alarms/notices/notice.entry";

@Pipe({name: 'fuelLimitReachedNotice'})
export class FuelLimitReachedNoticePipe implements PipeTransform {

  constructor(private translate: TranslateService) {
  }

  public transform(value: NoticeEntry): string {
    return value != null
      ? this.translate.instant('messages.notices.provider.' + value.additionalInfo)
      : '';
  }
}
